<div [@routerTransition]>
    <sub-header [title]="'Brands' | localize" [description]="'BrandsHeaderInfo' | localize">
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button
                    id="dropdownButtonExcelOperations"
                    dropdownToggle
                    type="button"
                    class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-controls="dropdownMenuExcelOperations"
                >
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul
                    id="dropdownMenuExcelOperations"
                    class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu"
                    *dropdownMenu
                    aria-labelledby="dropdownButtonExcelOperations"
                >
                    <li role="menuitem">
                        <a
                            class="dropdown-item text-gray-900"
                            id="ExportBrandsToExcelButton"
                            (click)="this.showExcelColumnSelectionModal()"
                            href="javascript:;"
                        >
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <li *ngIf="'Pages.Brands.Create' | permission" role="menuitem">
                        <a href="javascript:;" class="no-padding">
                            <span class="fileinput-button">
                                <p-fileUpload
                                    mode="basic"
                                    customUpload="true"
                                    name="ExcelFileUpload"
                                    #ExcelFileUpload
                                    maxFileSize="10000000"
                                    auto="auto"
                                    accept=".csv,.xls,.xlsx"
                                    (uploadHandler)="uploadExcel($event)"
                                    (onError)="onUploadExcelError()"
                                    chooseLabel="{{ 'ImportFromExcel' | localize }}"
                                ></p-fileUpload>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <button
                id="btn_create_brand"
                *ngIf="'Pages.Brands.Create' | permission"
                (click)="createBrand()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewBrand') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input
                                            [(ngModel)]="filterText"
                                            (ngModelChange)="getBrands()"
                                            name="filterText"
                                            autoFocus
                                            type="text"
                                            class="form-control"
                                            [placeholder]="l('SearchWithThreeDot')"
                                        />
                                        <button class="btn btn-primary" type="submit" (click)="getBrands()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>

                            <div class="col-md-12 mt-5">
                                <button
                                    (click)="resetFilters()"
                                    class="btn btn-secondary btn-sm"
                                    id="btn-reset-filters"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="!advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span
                                    class="clickable-item text-muted"
                                    *ngIf="advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown"
                                >
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getBrands($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Brands.Edit', 'Pages.Brands.Delete')"
                                    >
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="brand.name"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td
                                        style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.Brands.Edit', 'Pages.Brands.Delete')"
                                    >
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        *ngIf="permission.isGranted('Pages.Brands.Edit')"
                                                        class="dropdown-item"
                                                        (click)="createOrEditBrandModal.show(record.brand.id)"
                                                    >
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        class="dropdown-item"
                                                        href="javascript:;"
                                                        *ngIf="permission.isGranted('Pages.Brands.Delete')"
                                                        (click)="deleteBrand(record.brand)"
                                                    >
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Name') }}</span>
                                        {{ record.brand.name }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getBrands($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>
    <createOrEditBrandModal #createOrEditBrandModal (modalSave)="getBrands()"></createOrEditBrandModal>

    <excel-column-selection-modal
        (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal
    ></excel-column-selection-modal>
</div>
